/* eslint-disable react/no-unused-state */
import React from 'react'
import {
  IAddress,
  IAddressFormViewNavParams,
  IApiOptions,
  IPackageBillingCycle,
  IProfile,
  IProfileMap,
  IQuickAddress,
  IResponseGetSubscriptionsOrder,
  ISelectedStoreMap,
  ISubscriptionPackageList,
  IXSellyFile,
  SubscriptionPackageListItems,
} from 'x/index'
import * as util from 'x/utils/util'
import _ from 'lodash'
import dayjs from 'dayjs'
import * as NavActions from 'x/utils/navigation'
import * as upload from 'x/utils/upload'
import api from 'x/utils/api'
import p from 'x/config/platform-specific'
import CONS from 'x/config/constants'
import * as acl from 'x/utils/acl'

export interface ISelectedAddOn {
  sku: string
  billing_cycle: number
  qty: number
}

interface IBaseSelectedSubscriptionPackageViewProps {
  profile: IProfileMap
  selectedStore: ISelectedStoreMap
  subscription: any
  myStores: any
  fetchSubscription: any
}

interface IBaseSelectedSubscriptionPackageViewState {
  subscriptionPackageList: ISubscriptionPackageList
  profile: IProfile
  isLoading: boolean

  selectedOptionRangePackageIndex: number // รายบละเอียด package list จาก หลังบ้าน
  selectedMainPackage: SubscriptionPackageListItems // แพ็กหลักที่เลือก
  addOnPackages: ISelectedAddOn[] // แพ็กเสริมที่เลือก

  uploadedUrl: string
  paymentPostDate: Date

  pendingOrderData: IResponseGetSubscriptionsOrder

  mode: 'upgrade' | 'buy_package' | 'add_on' | 'continue_package' | 'pending'

  currentPackageBillingCycle: IPackageBillingCycle[]
  nextPackageBillingCycle: IPackageBillingCycle[]

  isvisibleChangeBillingCycle: boolean

  orderCountHistory: { start_date: string; end_date: string; order_count: number }[]

  isOrderCountHistory: boolean

  subscriptionAddressContact: IAddress
  isTaxReceiptRequested: boolean
  isTaxWithheld: boolean

  resultPayment: {
    total_amount: number
    vat_amount: number
    wh_tax_amount?: number
    sub_total_amount: number
  }

  quotaUsage: {
    order_count_quota: number
    external_integrations: {
      mkp: number
      erp: number
    }
    ug_quota: number
    pg_quota: number
    vd_quota: number
    wh_quota?: number
    store_count?: number
    helper_count?: number
  }
}

export default abstract class BaseSelectedSubscriptionPackageView extends React.Component<
  IBaseSelectedSubscriptionPackageViewProps,
  IBaseSelectedSubscriptionPackageViewState
> {
  inLoopPamyntChackProcess: boolean

  // eslint-disable-next-line react/no-unused-class-component-methods
  // @ts-ignore
  carouselRef: React.useRef<any>

  PACKAGE_SKU_CYCLE_1: string[]

  PACKAGE_SKU_CYCLE_12: string[]

  ADD_ON_COUNTSTANT: {
    title: string
    addOnKey: string
    cutSku: string
  }[]

  constructor(props) {
    super(props)
    this.state = {
      subscriptionPackageList: null,
      profile: null,
      selectedOptionRangePackageIndex: 3,
      selectedMainPackage: null,
      addOnPackages: null,
      uploadedUrl: null,
      paymentPostDate: new Date(),
      pendingOrderData: null,
      isLoading: true,
      mode: 'buy_package',
      currentPackageBillingCycle: null,
      nextPackageBillingCycle: null,
      isvisibleChangeBillingCycle: false,
      orderCountHistory: null,
      isOrderCountHistory: false,
      subscriptionAddressContact: null,
      isTaxReceiptRequested: false,
      isTaxWithheld: false,
      resultPayment: null,
      quotaUsage: null,
    }

    this.inLoopPamyntChackProcess = false

    this.ADD_ON_COUNTSTANT = [
      {
        title: 'ออเดอร์',
        addOnKey: 'order_count_quota',
        cutSku: 'ADDON-QUOTA-ORDER',
      },
      {
        title: 'การเชื่อมต่อ',
        addOnKey: 'mkp_quota',
        cutSku: 'ADDON-QUOTA-MKP',
      },
      {
        title: 'กลุ่มสมาชิก',
        addOnKey: 'ug_quota',
        cutSku: 'ADDON-QUOTA-UG',
      },
      {
        title: 'รายการราคา',
        addOnKey: 'pg_quota',
        cutSku: 'ADDON-QUOTA-PG',
      },
      {
        title: 'ผู้ช่วย',
        addOnKey: 'helper_count',
        cutSku: 'ADDON-QUOTA-HELPER',
      },
      {
        title: 'ร้านค้า',
        addOnKey: 'store_count',
        cutSku: 'ADDON-QUOTA-STORE',
      },
      {
        title: 'ส่วนลดขายส่ง',
        addOnKey: 'vd_quota',
        cutSku: 'ADDON-QUOTA-VD',
      },
      // {
      //   title: 'คลัง',
      //   addOnKey: 'wh_quota',
      //   cutSku: 'ADDON-QUOTA-WH',
      // },
    ]
  }

  async componentDidMount() {
    // console.log('BaseSelectedSubscriptionPackageView componentDidMount => ', this.props.subscription.toJS())
    const isOwner = acl.isSelectedStoreOwner()
    if (!isOwner) {
      p.op.showConfirmationOkOnly('', 'คุณไม่มีสิทธิ์ในการใช้งานฟีเจอร์นี้')
      // @ts-ignore
      util.navGoBack(this.props)
      return
    }
    await this._setProfile()
    await this._setQuotaUsage()
    await this._setCurrentAndNextPackageBillingCycle()
    await this._getSubscriptionPackageList()
    await this._getSubscriptionOrder()
    await this._getSubscriptionAddress()
    await this._validateOrder()

    this._addOnDubledNav()
  }

  _setQuotaUsage = async () => {
    const { subscription } = this.props
    const subscriptionJS = subscription.toJS()
    const quotaUsage = _.has(subscriptionJS, 'quota_usage') ? subscriptionJS.quota_usage : null
    // console.log('quotaUsage => ', quotaUsage)
    if (_.isNil(quotaUsage)) {
      return
    }
    await util.setStatePromise(this, {
      quotaUsage: {
        external_integrations: {
          mkp: quotaUsage.mkp || 0,
          erp: quotaUsage.erp || 0,
        },
        order_count_quota: quotaUsage.order_count || 0,
        ug_quota: quotaUsage.ug || 0,
        pg_quota: quotaUsage.pg || 0,
        vd_quota: quotaUsage.vd || 0,
        wh_quota: quotaUsage.wh || 0,
        store_count: quotaUsage.store_count || 0,
        helper_count: quotaUsage.helper_count || 0,
      },
    })
  }

  _addOnDubledNav = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { addOnDubledNav } = params
    // console.log('addOnDubledNav => ', addOnDubledNav)
    let cutSku = null
    this.ADD_ON_COUNTSTANT.forEach((item) => {
      if (item.addOnKey === addOnDubledNav) {
        cutSku = item.cutSku
      }
    })
    if (!_.isNil(addOnDubledNav)) {
      this._onPressAddOn(cutSku)
    }
  }

  _navToPaymentFromParams = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { navToPayment } = params
    // console.log('navToPayment => ', navToPayment)
    if (!_.isNil(navToPayment) && navToPayment) {
      this._navToPaymentSubscriptionView()
    }
  }

  _validateOrder = async () => {
    const { profile, mode, addOnPackages, selectedMainPackage, isTaxWithheld, isTaxReceiptRequested, pendingOrderData } = this.state
    // console.log('addOnPackages => ', addOnPackages)
    if (_.isNil(profile) || _.isNil(selectedMainPackage) || !_.isNil(pendingOrderData)) {
      return
    }
    const { subscription } = this.props
    const isXsellierx = util.isXsellier(subscription)
    let PURCHASABLES_ID = CONS.PURCHASABLES_ID.SCB
    if (p.op.isIOS() && isXsellierx === false) {
      PURCHASABLES_ID = CONS.PURCHASABLES_ID.IOS
    }
    // console.log('addOnPackages /=> ', addOnPackages)

    const newAddOnPackages = _.cloneDeep(addOnPackages)
    const items = _.isNil(newAddOnPackages) || newAddOnPackages.length === 0 ? [] : newAddOnPackages
    // console.log('selectedMainPackage => ', selectedMainPackage)
    let mainPackage = null
    if (!_.isNil(selectedMainPackage)) {
      mainPackage = {
        sku: selectedMainPackage.sku,
        billing_cycle: selectedMainPackage.billing_cycle,
        qty: 1,
      }
    }
    // return
    // console.log('mainPackage => ', mainPackage)
    if (mode !== 'add_on') {
      items.push(mainPackage)
    }
    // console.log('items /=> ', items)
    if (items.length === 0) {
      return
    }
    // console.log('items /=> ', items)

    const reqBody = {
      user_id: profile.user_id,
      purchase_channel_id: PURCHASABLES_ID,
      items,
      is_vat: true,
      is_tax_withheld: isTaxWithheld && isTaxReceiptRequested,
    }

    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    const res = await api.postV2('xselly/order/subscription/validate', reqBody, apiOptions)
    // console.log('res => ', res)

    if (_.has(res, 'total_amount')) {
      await util.setStatePromise(this, {
        resultPayment: {
          sub_total_amount: res.sub_total_amount,
          total_amount: res.total_amount,
          vat_amount: res.vat_amount,
          wh_tax_amount: res?.wh_tax_amount || 0,
        },
      })
    }
  }

  _getSubscriptionAddress = async () => {
    const reqBody = {
      is_pending: true,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2('xselly/contact/get', reqBody, apiOptions)
    // console.log('res => ', res)
    if (res.id) {
      const isShowWithheld = this._showWithheld()
      await util.setStatePromise(this, {
        subscriptionAddressContact: res.billing_address,
        isTaxReceiptRequested: true,
        isTaxWithheld: isShowWithheld,
      })
    }
  }

  _setCurrentAndNextPackageBillingCycle = async () => {
    const { subscription } = this.props
    if (_.isNil(subscription)) {
      return null
    }
    const currentPackageBillingCycle = subscription.has('current_package_billing_cycle')
      ? subscription.get('current_package_billing_cycle').toJS()
      : null
    const nextPackageBillingCycle = subscription.has('next_package_billing_cycle')
      ? subscription.get('next_package_billing_cycle').toJS()
      : null
    await util.setStatePromise(this, { currentPackageBillingCycle, nextPackageBillingCycle })
  }

  _getSubscriptionOrder = async () => {
    const { subscriptionPackageList } = this.state
    const reqBody = {
      is_pending: true,
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { sku, mode, skipRecommendPackage, billingCycleForUpgradePackage } = params
    const res = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody, apiOptions)
    // console.log('res => ', res)
    if (res?.id) {
      const { items } = res
      const mainPackageSku = items.find((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // console.log('mainPackageSku => ', mainPackageSku)
      let seletedMainPackageSku = sku
      if (!_.isNil(mainPackageSku)) {
        seletedMainPackageSku = mainPackageSku.sku
      }
      const mainPackage = subscriptionPackageList.items.find((item) => item.sku === seletedMainPackageSku)
      // console.log('mainPackage // => ', mainPackage)
      const addOnPackages = items.filter((item) => !_.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      if (!_.isNil(mainPackageSku)) {
        mainPackage.billing_cycle = mainPackageSku.billing_cycle
      }
      await util.setStatePromise(this, {
        pendingOrderData: res,
        selectedMainPackage: mainPackage,
        addOnPackages,
        isLoading: false,
        isTaxReceiptRequested: res.is_tax_receipt_requested,
        isTaxWithheld: res.is_tax_withheld,
        subscriptionAddressContact: _.has(res, 'billing_address') ? res.billing_address : null,
      })
      // _navToPaymentFromParams ไว้ช็ดว่าต้องการไปหน้าจ่ายเงินเลยไหม ถ้าใช่ก็ nav ต่อทันที
      this._navToPaymentFromParams()
      if (res.status === 'pending') {
        await util.delay(5000)
        this.inLoopPamyntChackProcess = true
        await this._loopChackPayment()
      }
    } else {
      // set main package และ add on หากไม่มี pending package
      let selectedMainPackage = null
      let selectedMainPackageSku = sku
      if (mode === 'continue_package' || (mode === 'add_on' && skipRecommendPackage === false)) {
        selectedMainPackageSku = await this._getRecommendPackage()
      }
      if (mode === 'add_on') {
        selectedMainPackageSku = sku
      }
      const { items } = subscriptionPackageList
      if (!_.isNil(items)) {
        items.forEach((item) => {
          if (item.sku === selectedMainPackageSku) {
            selectedMainPackage = item
          }
        })
      }
      if (mode === 'upgrade') {
        selectedMainPackage.billing_cycle = _.isNil(billingCycleForUpgradePackage) ? 1 : billingCycleForUpgradePackage
      }
      // console.log('selectedMainPackage // => ', selectedMainPackage)
      await util.setStatePromise(this, { isLoading: false, selectedMainPackage })
      if (skipRecommendPackage === true) {
        await util.setStatePromise(this, {
          addOnPackages: [],
        })
      }
    }
  }

  _setLoading = () => {
    this.setState({ isLoading: true })
  }

  _unSetLoading = () => {
    this.setState({ isLoading: false })
  }

  // _getRecommendPackage จะยิง api ออกไปเพื่อขอข้อมูลแพ็กเกจจากหลังบ้าน เพื่อนำมาใช้ในกรณีต่อแพ็กเกจอีกรอบ หรือ ซื้อแพ็กเสริม หน้าบ้านจะได้รู้ว่าจะต้องหยิบแพ็กเกจไหนมาให้
  _getRecommendPackage = async (type?: number) => {
    const { profile } = this.state
    if (_.isNil(profile)) {
      return null
    }
    // @ts-ignore
    const params = util.getNavParams(this.props)

    const { mode } = params
    const reqBody = {
      user_id: profile.user_id,
    }
    if (!_.isNil(type)) {
      // @ts-ignore
      reqBody.type = type
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    const res = await api.postV2('xselly/subscription/package/recommend', reqBody, apiOptions)
    // console.log('res // => ', res)
    // กรณี mode ซื้อแพ็กเสริม('add_on') ไม่ต้องเซตแพ็กเสริม เพราะต้องการแค่ sku แพ็กหลัก
    if (mode === 'continue_package') {
      await util.setStatePromise(this, {
        addOnPackages: res.addon_items,
      })
    }

    if (res.main_item) {
      if (res.order_count_history) {
        await util.setStatePromise(this, {
          orderCountHistory: res.order_count_history,
        })
      }
      return res.main_item.sku
    }

    return null
  }

  _getSubscriptionPackageList = async () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { mode } = params
    try {
      const res = await util.fetchSubscriptionPackageList(this.props.subscription)
      // console.log('_fetchSubscriptionPackageList res => ', res)
      await util.setStatePromise(this, {
        subscriptionPackageList: res,
        mode: _.isNil(mode) ? 'buy_package' : mode,
      })
      // if (!res || _.isEmpty(res)) {
      // }
    } catch (err) {}
    // await util.setStatePromise(this, {
    //   subscriptionPackageList,
    //   mode: _.isNil(mode) ? 'buy_package' : mode,
    // })
  }

  // eslint-disable-next-line react/no-unused-class-component-methods
  goBack = () => {
    // @ts-ignore
    const { navigation } = this.props
    const { pendingOrderData, mode } = this.state
    const params = this._getParams()
    const { succeedPaymentCallBack } = params
    if (_.isFunction(succeedPaymentCallBack) && !_.isNil(pendingOrderData)) {
      succeedPaymentCallBack()
      // @ts-ignore
      util.navGoBack(this.props)
      return
    }
    // if (mode === 'continue_package') {
    //   // navigation.pop(2)
    //   // @ts-ignore
    //   util.navGoBack(this.props)
    //   return
    // }
    // @ts-ignore
    util.navGoBack(this.props)
  }

  _callbackSucceedChangeContinuePackage = async (sku: string, selectedBillingCycle: number) => {
    // console.log('_callbackSucceedChangeContinuePackage => ', sku)
    const type = util.getSubscriptionTypeBySku(sku)
    const mainPackageSku = await this._getRecommendPackage(type)
    const { subscriptionPackageList } = this.state
    const selectedMainPackage = subscriptionPackageList.items.find((item) => item.sku === mainPackageSku)
    selectedMainPackage.billing_cycle = selectedBillingCycle
    await util.setStatePromise(this, {
      selectedMainPackage,
    })
    // console.log('selectedMainPackage => ', selectedMainPackage)
    this._onChangeBillingCycle(selectedMainPackage.billing_cycle)

    // await this._validateOrder()
  }

  _onClickChangeContinuePackage = () => {
    const { selectedMainPackage, mode } = this.state
    // @ts-ignore
    // util.navGoBack(this.props)
    // const mode = 'continue_package'
    // console.log('mode => ', mode)
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionPackageList } = this.state
    navigation.dispatch(
      NavActions.navToInAppPurchaseView({
        subscriptionPackageList,
        mode,
        callBackSucceedPaymentIos: () => null,
        succeedPaymentCallBack: () => null,
        callbackSucceedChangeContinuePackage: (sku: string, selectedBillingCycle: number) =>
          this._callbackSucceedChangeContinuePackage(sku, selectedBillingCycle),
        sku: selectedMainPackage.sku,
      })
    )
  }

  _setProfile = async (): Promise<void> => {
    const { profile } = this.props
    const profileJS = profile?.toJS() || null
    await util.setStatePromise(this, {
      profile: profileJS,
    })
  }

  // _getAddOnDataByCutSku = (cutSku: string) => {
  //   const { subscriptionPackageList, addOnPackages } = this.state
  //   if (_.isNil(addOnPackages)) {
  //     return null
  //   }

  //   let fullSku = null
  //   addOnPackages.forEach((addOn) => {
  //     const { sku } = addOn
  //     const isPrefix = sku.startsWith(cutSku)
  //     if (isPrefix) {
  //       fullSku = sku
  //     }
  //   })

  //   if (_.isNil(fullSku)) {
  //     return null
  //   }

  //   const { items } = subscriptionPackageList
  //   let jsonData = null
  //   items.forEach((item) => {
  //     const { sku } = item
  //     if (sku === fullSku) {
  //       jsonData = item
  //     }
  //   })
  //   return jsonData
  // }

  _getSelectedAddOnDataByCutSku = (cutSku: string) => {
    const { subscriptionPackageList, addOnPackages } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(addOnPackages)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    const fullSku = addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku))?.sku

    // If no matching SKU is found, return null.
    if (_.isNil(fullSku)) {
      return null
    }

    // Use the find method to locate the item in subscriptionPackageList with the matching SKU.
    const jsonData = subscriptionPackageList.items.find((item) => item.sku === fullSku) || null

    return jsonData
  }

  // This function retrieves the selected add-on package based on the provided cutSku.
  _getAddOnSelectedData = (cutSku: string) => {
    const { addOnPackages } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(addOnPackages)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    // If no matching add-on is found, return null.
    return addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku)) || null
  }

  _getAddOnSelectedDataBySku = (sku: string) => {
    const { subscriptionPackageList } = this.state
    return subscriptionPackageList.items.find((item) => item.sku === sku) || null
  }

  _getStartAndEndBillingCycle = (billingCycle: number) => {
    const { subscriptionPackageList } = this.state
    // console.log('subscriptionPackageList => ', subscriptionPackageList)
    const { future_billing_dates, current_billing_dates } = subscriptionPackageList
    let startBillingDate = current_billing_dates
    // ถ้าแพ็กฟรีมาเลยจะไม่มี current_billing_dates
    if (_.isNil(current_billing_dates) || current_billing_dates.length === 0) {
      startBillingDate = future_billing_dates
    }
    const { start } = startBillingDate[0]
    const { end } = future_billing_dates[billingCycle - 1]
    return `${dayjs(start, 'YYYY-MM-DD').format('D MMM YYYY')} - ${dayjs(end, 'YYYY-MM-DD').format('D MMM YYYY')}`
  }

  _getCurrentSelectedAddOnDataByCutSku = (cutSku: string) => {
    const { subscriptionPackageList, currentPackageBillingCycle } = this.state

    // If addOnPackages is null or undefined, return null.
    if (_.isNil(currentPackageBillingCycle)) {
      return null
    }

    // Use the find method to locate the first add-on package whose SKU starts with cutSku.
    const fullSku = currentPackageBillingCycle.find((addOn) => addOn.sku.startsWith(cutSku))?.sku

    // If no matching SKU is found, return null.
    if (_.isNil(fullSku)) {
      return null
    }

    // Use the find method to locate the item in subscriptionPackageList with the matching SKU.
    const jsonData = subscriptionPackageList.items.find((item) => item.sku === fullSku) || null

    return jsonData
  }

  _callBackFormSelectedAddOn = async (addOnSelectedList: ISelectedAddOn[], cutSku: string) => {
    // console.log('addOnSelectedList => ', addOnSelectedList)
    // console.log('cutSku => ', cutSku)
    const { addOnPackages } = this.state
    if (_.isNil(addOnPackages) || addOnPackages.length === 0) {
      // this.setState({ addOnPackages: addOnSelectedList })
      await util.setStatePromise(this, {
        addOnPackages: addOnSelectedList,
      })
      await this._validateOrder()
    } else if (_.isNil(addOnSelectedList) || addOnSelectedList.length === 0) {
      const newAddOnPackages = addOnPackages.filter((addOn) => !addOn.sku.startsWith(cutSku))
      // this.setState({ addOnPackages: newAddOnPackages })
      await util.setStatePromise(this, {
        addOnPackages: newAddOnPackages,
      })
      await this._validateOrder()
    } else {
      const oldAddOnPackages = _.cloneDeep(addOnPackages)
      // console.log('oldAddOnPackages => ', oldAddOnPackages)
      const newAddOnPackages = oldAddOnPackages.filter((addOn) => !addOn.sku.startsWith(cutSku))
      // console.log('newAddOnPackages => ', newAddOnPackages)
      addOnSelectedList.forEach((addOnSelected) => {
        newAddOnPackages.push(addOnSelected)
      })

      await util.setStatePromise(this, {
        addOnPackages: newAddOnPackages,
      })
      await this._validateOrder()
    }
  }

  // SUBSCRIPTION_UPGRADE_PACKAGE_SKU: [
  //   'BRONZE-TO-SILVER-CYCLE-1',
  //   'BRONZE-TO-GOLD-CYCLE-1',
  //   'BRONZE-TO-PLATINUM-CYCLE-1',

  //   'SILVER-TO-GOLD-CYCLE-1',
  //   'SILVER-TO-PLATINUM-CYCLE-1',

  //   'GOLD-TO-PLATINUM-CYCLE-1',
  // ]

  _getMainPackageByUpgradePackageMode = () => {
    const { selectedMainPackage, subscriptionPackageList } = this.state
    const { sku } = selectedMainPackage
    let shortMainSku = 'PACKAGE-SILVER-CYCLE'
    if (sku.match(/TO-GOLD/)) {
      shortMainSku = 'PACKAGE-GOLD-CYCLE'
    }
    if (sku.match(/TO-PLATINUM/)) {
      shortMainSku = 'PACKAGE-PLATINUM-CYCLE'
    }
    const { items } = subscriptionPackageList
    let selectedAddOn = null
    items.forEach((item) => {
      if (item.sku.includes(shortMainSku)) {
        selectedAddOn = item
      }
    })
    selectedAddOn.billing_cycle = selectedMainPackage.billing_cycle
    return selectedAddOn
  }

  // shortSku EX :: 'ADDON-QUOTA-ORDER' // FULL SKU EX :: 'ADDON-QUOTA-ORDER-100'
  _onPressAddOn = (shortSku: string) => {
    // console.log('shortSku => ', shortSku)
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionPackageList, selectedMainPackage, mode } = this.state
    // upgrade package mode ต้้องไปเป็น main package subtype ก่อน
    const mainPackage = mode !== 'upgrade' ? selectedMainPackage : this._getMainPackageByUpgradePackageMode()
    // console.log('mainPackage => ', mainPackage)
    // @ts-ignore
    const params = util.getNavParams(this.props)
    const { addOnDubledNav } = params
    navigation.dispatch(
      NavActions.navToSelectAddOnOrderView({
        subscriptionPackageList,
        sku: shortSku,
        selectedPackage: mainPackage,
        callBackFromSelectedAddOn: (addOnSelectedList, cutSku) => this._callBackFormSelectedAddOn(addOnSelectedList, cutSku),
        selectedAddOn: null,
        mode: this.state.mode,
        orderCountHistory: shortSku.includes('ADDON-QUOTA-ORDER') ? this.state.orderCountHistory : null,
        addOnDubledNav,
      })
    )
  }

  // shortSku EX :: 'ADDON-QUOTA-ORDER' // FULL SKU EX :: 'ADDON-QUOTA-ORDER-100'
  _onPressEditAddOn = (shortSku: string) => {
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionPackageList, selectedMainPackage, mode } = this.state
    const addOnFromCutSku = this._getAddOnSelectedListData(shortSku)
    // upgrade package mode ต้้องไปเป็น main package subtype ก่อน
    const mainPackage = mode !== 'upgrade' ? selectedMainPackage : this._getMainPackageByUpgradePackageMode()
    navigation.dispatch(
      NavActions.navToSelectAddOnOrderView({
        subscriptionPackageList,
        sku: shortSku,
        selectedPackage: mainPackage,
        callBackFromSelectedAddOn: (addOnSelectedList, cutSku) => this._callBackFormSelectedAddOn(addOnSelectedList, cutSku),
        selectedAddOn: addOnFromCutSku,
        mode: this.state.mode,
        orderCountHistory: shortSku.includes('ADDON-QUOTA-ORDER') ? this.state.orderCountHistory : null,
      })
    )
  }

  _getSelectedAddOn = (sku: string) => {
    if (_.isNil(sku)) {
      return null
    }
    const { subscriptionPackageList } = this.state
    const { items } = subscriptionPackageList
    let selectedAddOn = null
    items.forEach((item) => {
      if (item.sku === sku) {
        selectedAddOn = item
      }
    })
    return selectedAddOn
  }

  _getAddOnSelectedListData = (cutSku: string) => {
    const { addOnPackages } = this.state

    if (_.isNil(addOnPackages)) {
      return null
    }

    const listAddOn = []
    // addOnPackages.find((addOn) => addOn.sku.startsWith(cutSku)) || null
    addOnPackages.forEach((addOn) => {
      const { sku } = addOn
      const isPrefix = sku.startsWith(cutSku)
      if (isPrefix) {
        listAddOn.push(addOn)
      }
    })
    return listAddOn
  }

  _getAddOnCount = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { addOnPackages } = this.state
    let countAddOn = 0
    if (_.isNil(addOnPackages)) {
      return countAddOn
    }
    const addOnFromCutSku = this._getAddOnSelectedListData(addOn.cutSku)
    addOnFromCutSku.forEach((addOnSelected) => {
      const getAddOn = this._getAddOnSelectedDataBySku(addOnSelected.sku)
      const countQty = getAddOn.data_json[addOn.addOnKey] * addOnSelected.qty
      countAddOn += countQty
    })
    return countAddOn
  }

  // _onSubmitUpload = async () => {
  //   this._setLoading()
  //   // @ts-ignore มันคือ IXSellyFile แต่ไม่ได้ประกาศใน state
  //   const { selectedFile, paymentPostDate } = this.state
  //   // console.log('_onTestUploadPress selectedFile', selectedFile)

  //   if (_.isNil(selectedFile)) {
  //     p.op.showConfirmationOkOnly('', 'กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
  //     this._unSetLoading()
  //     return
  //   }

  //   const YYMM = dayjs(paymentPostDate).format('YYMM')
  //   const YYMMDD = dayjs(paymentPostDate).format('YYMMDD')
  //   const HHMMSS = dayjs(paymentPostDate).format('HHmmss')
  //   const fileName = `/subs_payment_slip_${YYMMDD}_${HHMMSS}`
  //   const path = `subs/payment_slip/${YYMM}/${YYMMDD}_${HHMMSS}`
  //   try {
  //     // console.log('_onTestUploadPress file', selectedFile)
  //     const uploadResponse = await upload.uploadFile(selectedFile as IXSellyFile, { fileName, folderPath: path })
  //     // console.log('_onTestUploadPress uploadResponse', uploadResponse)
  //     // @ts-ignore
  //     await util.setStatePromise(this, { uploadedUrl: uploadResponse.url })
  //     await this._onSubmitPayment()
  //   } catch (error) {
  //     // console.log('_onTestUploadPress error', error)
  //     // p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${error}`)
  //     await util.setStatePromise(this, { uploadedUrl: null })
  //     this._unSetLoading()
  //   }
  // }

  // _onSubmitUploadDayAddOne = async () => {
  //   this._setLoading()
  //   // @ts-ignore มันคือ IXSellyFile แต่ไม่ได้ประกาศใน state
  //   const { selectedFile, paymentPostDate } = this.state
  //   // console.log('_onTestUploadPress selectedFile', selectedFile)

  //   if (_.isNil(selectedFile)) {
  //     p.op.showConfirmationOkOnly('', 'กรุณาเลือกไฟล์ที่ต้องการอัพโหลด')
  //     this._unSetLoading()
  //     return
  //   }

  //   const YYMM = dayjs(paymentPostDate).format('YYMM')
  //   const YYMMDD = dayjs(paymentPostDate).format('YYMMDD')
  //   const HHMMSS = dayjs(paymentPostDate).format('HHmmss')
  //   const fileName = `/subs_payment_slip_${YYMMDD}_${HHMMSS}`
  //   const path = `subs/payment_slip/${YYMM}/${YYMMDD}_${HHMMSS}`
  //   try {
  //     // console.log('_onTestUploadPress file', selectedFile)
  //     const uploadResponse = await upload.uploadFile(selectedFile as IXSellyFile, { fileName, folderPath: path })
  //     // console.log('_onTestUploadPress uploadResponse', uploadResponse)
  //     // @ts-ignore
  //     await util.setStatePromise(this, { uploadedUrl: uploadResponse.url })
  //     await this._onSubmitPaymentDayAddOne()
  //   } catch (error) {
  //     // console.log('_onTestUploadPress error', error)
  //     // p.op.showConfirmationOkOnly('', `เกิดข้อผิดพลาด ${error}`)
  //     await util.setStatePromise(this, { uploadedUrl: null })
  //     this._unSetLoading()
  //   }
  // }

  _getSumTotalPayment = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { price_with_vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += price_with_vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.price_with_vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalPriceBeforeVat = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { price_before_vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += price_before_vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.price_before_vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalVat = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { vat } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += vat
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.vat * qty * billing_cycle
      })
    }
    return price
  }

  _getSumTotalWhTex = () => {
    const { selectedMainPackage, addOnPackages, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return 0
    }

    const { wh_tax } = selectedMainPackage
    let price = 0
    if (mode !== 'add_on') {
      price += wh_tax
    }
    if (!_.isNil(addOnPackages)) {
      addOnPackages.forEach((addOn) => {
        const { billing_cycle, qty, sku } = addOn
        const selectedPackage = this._getAddOnSelectedDataBySku(sku)
        price += selectedPackage.wh_tax * qty * billing_cycle
      })
    }
    return price
  }

  _showWithheld = () => {
    const { resultPayment } = this.state
    if (_.isNil(resultPayment)) {
      return false
    }
    const { wh_tax_amount } = resultPayment
    // const price = this._getSumTotalPayment()
    return !_.isNil(wh_tax_amount) && wh_tax_amount > 0
    // const price = this._getSumTotalPayment()
    // return price >= 1000
  }

  _onChangePaymentPostDate = (newDate: Date) => {
    this.setState({ paymentPostDate: newDate })
  }

  _getParams = () => {
    // @ts-ignore
    const params = util.getNavParams(this.props)
    return params
  }

  _onChangeBillingCycle = async (month: number) => {
    const { selectedMainPackage, subscriptionPackageList, addOnPackages } = this.state
    const mainPackageSku = selectedMainPackage.sku
    const cleanedSku = mainPackageSku.replace(/\d+/g, '') // Remove numbers from sku
    const sku = cleanedSku + month
    // console.log('sku => ', sku)
    let selectedNewMainPackage = null
    const { items } = subscriptionPackageList
    if (!_.isNil(items)) {
      items.forEach((item) => {
        if (item.sku === sku) {
          selectedNewMainPackage = item
        }
      })
    }
    selectedNewMainPackage.billing_cycle = month
    // console.log('selectedNewMainPackage => ', selectedNewMainPackage)
    const newAddOnPackages = []
    if (!_.isNil(addOnPackages) && addOnPackages.length > 0) {
      addOnPackages.forEach((addOn) => {
        const newAddon: ISelectedAddOn = { sku: '', billing_cycle: 0, qty: 0 }
        newAddon.sku = addOn.sku
        newAddon.qty = addOn.qty
        newAddon.billing_cycle = month
        newAddOnPackages.push(newAddon)
      })
    }
    // this.setState({ selectedMainPackage: selectedNewMainPackage, addOnPackages: newAddOnPackages })

    await util.setStatePromise(this, {
      selectedMainPackage: selectedNewMainPackage,
      addOnPackages: newAddOnPackages,
    })
    await this._validateOrder()
  }

  _getDifferenceFromMainPackageAndNowPackage = (key: string) => {
    const { subscription } = this.props
    const { selectedMainPackage, mode } = this.state
    const { data_json } = selectedMainPackage
    let newDataJsonMainPackage = _.cloneDeep(data_json)
    if (mode === 'upgrade') {
      // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
      const newSelectedMainPackage = this._getMainPackageByUpgradePackageMode()
      newDataJsonMainPackage = _.cloneDeep(newSelectedMainPackage.data_json)
    }
    const value = !_.isNil(newDataJsonMainPackage) ? newDataJsonMainPackage[key] : 0
    const orderCountQuota = subscription.get(key)
    return orderCountQuota - value
  }

  _addOnOutDate = (endDate: string) => {
    const { mode } = this.state
    return dayjs(endDate).isBefore(dayjs()) && mode === 'add_on'
  }

  _getSumAddonCurrentPackageBillingCycle = (cutSku: string, addonKey: string) => {
    const { mode } = this.state
    // console.log('mode => ', mode)
    if (mode === 'continue_package') {
      return 0
    }
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle) || currentPackageBillingCycle.length === 0) {
      return 0
    }
    let sumTatal = 0
    currentPackageBillingCycle.forEach((item) => {
      if (item.sku.startsWith(cutSku)) {
        const { data_json, qty } = item
        const isOutDate = this._addOnOutDate(item.end_date)
        // ถ้าเป็น add_on และหมดอายุแล้ว จะไม่นำมาคิดยอดรวม
        if (!_.isNil(data_json) && !isOutDate) {
          sumTatal += data_json[addonKey] * qty
        }
      }
    })
    return sumTatal
  }

  _getAddonCurrentPackageBillingCycle = (cutSku: string) => {
    const { currentPackageBillingCycle } = this.state
    if (_.isNil(currentPackageBillingCycle) || currentPackageBillingCycle.length === 0) {
      return null
    }
    const sumTatal = []
    currentPackageBillingCycle.forEach((item) => {
      if (item.sku.startsWith(cutSku)) {
        sumTatal.push(item)
      }
    })
    return sumTatal
  }

  _getMainPackageStarDateEndDateText = () => {
    const { currentPackageBillingCycle } = this.state
    // console.log('currentPackageBillingCycle => ', currentPackageBillingCycle)
    const endDate = () => {
      const { subscription } = this.props
      const endPackage = dayjs(subscription.get('m_e_date'), 'YYYY-MM-DD').clone().format('D MMM YYYY')
      return `ถึง ${endPackage}`
    }
    if (_.isNil(currentPackageBillingCycle)) {
      return endDate()
    }
    let mainPackage = null
    currentPackageBillingCycle.forEach((item) => {
      if (item.item_type === 'package_main') {
        mainPackage = item
      }
    })
    if (_.isNil(mainPackage)) {
      return endDate()
    }
    const { start_date, end_date } = mainPackage
    const startPackage = dayjs(start_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
    const endDataPackage = dayjs(end_date, 'YYYY-MM-DD').clone().format('D MMM YYYY')
    return `${startPackage} - ${endDataPackage}`
  }

  _onSaveQuickAddress = async (newAddr: IQuickAddress) => {
    // console.log('newAddr => ', newAddr)
    // @ts-ignore
    util.navGoBack(this.props)
    const { subscriptionAddressContact } = this.state
    const apiMode = _.isNil(subscriptionAddressContact) ? 'create' : 'update'
    // return
    const reqBody = {
      name: newAddr.name,
      // @ts-ignore
      address1: newAddr.address1,
      address2: newAddr.address2,
      sub_district: newAddr.sub_district,
      district: newAddr.district,
      province: newAddr.province,
      postal_code: newAddr.postal_code,
      telephone: newAddr.telephone,
      legal_entity_type: `${newAddr.legal_entity_type}`,
      legal_entity_id: _.has(newAddr, 'legal_entity_id') && !_.isNil(newAddr.legal_entity_id) ? `${newAddr.legal_entity_id}` : '',
      // branch_number: newAddr.branch_number,
      email: newAddr.email,
    }
    if (_.has(newAddr, 'branch_number') && !_.isNil(newAddr.branch_number)) {
      // @ts-ignore
      reqBody.branch_number = newAddr.branch_number
      // @ts-ignore
      reqBody.branch_type = newAddr.branch_type
    }
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }
    if (apiMode === 'update') {
      // @ts-ignore
      reqBody.address_id = subscriptionAddressContact.id
    }
    if (_.has(newAddr, 'note')) {
      // @ts-ignore
      reqBody.note = newAddr.note
    }
    const res = await api.postV2(`xselly/address/${apiMode}`, reqBody, apiOptions)
    // console.log('res => ', res)
    if (res.id) {
      await util.setStatePromise(this, { subscriptionAddressContact: res, isTaxReceiptRequested: true })
    }
  }

  _navToEditAddressView = async () => {
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionAddressContact, pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      return
    }
    const _onSubmit = async (newAddr: IQuickAddress) => {
      const isSuccess = await this._onSaveQuickAddress(newAddr)
      return { isGoBack: isSuccess }
    }

    const initAddress: any = {}

    if (!_.isNil(subscriptionAddressContact)) {
      initAddress.name = subscriptionAddressContact.name
      initAddress.address1 = subscriptionAddressContact.address1
      initAddress.address2 = subscriptionAddressContact.address2
      initAddress.sub_district = subscriptionAddressContact.sub_district
      initAddress.district = subscriptionAddressContact.district
      initAddress.province = subscriptionAddressContact.province
      initAddress.postal_code = subscriptionAddressContact.postal_code
      initAddress.telephone = subscriptionAddressContact.telephone
      initAddress.legal_entity_type = subscriptionAddressContact.legal_entity_type
      initAddress.legal_entity_id = subscriptionAddressContact.legal_entity_id
      initAddress.email = subscriptionAddressContact.email
      initAddress.note = subscriptionAddressContact.note
      initAddress.id = subscriptionAddressContact.id
      initAddress.disbleAddress2 = true
      initAddress.branch_number = subscriptionAddressContact.branch_number || null
      initAddress.branch_type = subscriptionAddressContact.branch_type || null
    }

    const navParams: IAddressFormViewNavParams = {
      initAddress,
      submitButtonText: 'บันทึก',
      headerTitle: 'แก้ไขที่อยู่ใบกํากับภาษี',
      // @ts-ignore
      onSubmit: _onSubmit,
      type: 'subscriber_address',
    }

    navigation.dispatch(NavActions.navToAddressFormView(navParams))
  }

  _checkQuotaUsage = () => {
    const { quotaUsage } = this.state
    if (_.isNil(quotaUsage)) {
      return null
    }
    let quotaUsageText = ''
    this.ADD_ON_COUNTSTANT.forEach((addOn, idx) => {
      const { addOnKey } = addOn
      let quotaUse = addOnKey === 'mkp_quota' ? quotaUsage.external_integrations : quotaUsage[addOnKey]
      if ((addOnKey !== 'mkp_quota' && _.isNil(quotaUse)) || quotaUse === 0) {
        return null
      }
      if (
        (addOnKey === 'mkp_quota' && _.isNil(quotaUsage.external_integrations)) ||
        (addOnKey === 'mkp_quota' && quotaUsage.external_integrations.mkp === 0 && quotaUsage.external_integrations.erp === 0)
      ) {
        return null
      }
      if (addOnKey === 'mkp_quota') {
        quotaUse = quotaUsage.external_integrations.mkp + quotaUsage.external_integrations.erp
      }
      const unit = util.getUnitNameByDataJsonKey(addOnKey)
      const quotaUesTotal = this._getSumTotalQuota(addOn)

      if (quotaUse > quotaUesTotal) {
        quotaUsageText += idx === 0 ? `*${unit}*` : ` *${unit}*`
      }
    })

    return quotaUsageText.length > 0 ? quotaUsageText : null
  }

  _confirmQuotaUsage = async () => {
    const checkQuotaUsage = this._checkQuotaUsage()
    if (_.isNil(checkQuotaUsage)) {
      return true
    }
    const confirm = await new Promise<boolean>((passConfirm) => {
      p.op.showConfirmation(
        'แพ็กเกจที่เลือกอาจไม่เพียงพอต่อการใช้งาน',
        `จากข้อมูลการใช้งานที่แสดงในวงเล็บสีแดง แพ็กเกจที่คุณเลือกมีโควตาการใช้ฟีเจอร์*ไม่เพียงพอ*ต่อการใช้งานในปัจจุบัน (ซึ่งคือ ${checkQuotaUsage}) ซึ่งจะทำให้*ไม่สามารถเปิดออเดอร์ได้*ในรอบบิลนั้นๆที่โควตาไม่เพียงพอ คุณสามารถเลือกทำ 1 ใน 3 วิธี เพื่อให้มีโควตาเพียงพอต่อการใช้งาน ดังนี้
        \n1. ซื้อแพ็กเสริม
        \n2. อัพเกรดแพ็ก
        \n3. ลดการใช้งานโควตาที่เกินในรอบบิลนั้นๆ`,
        () => passConfirm(false),
        () => passConfirm(true),
        'ปิด',
        'ยืนยันคำสั่งซื้อแม้โควตาไม่พอ'
      )
    })
    return confirm
  }

  _onSubmitPayment = async () => {
    const {
      addOnPackages,
      selectedMainPackage,
      profile,
      paymentPostDate,
      subscriptionPackageList,
      mode,
      isTaxReceiptRequested,
      isTaxWithheld,
      subscriptionAddressContact,
      resultPayment,
    } = this.state
    if (_.isNil(resultPayment)) {
      p.op.showConfirmationOkOnly('คุณยังไม่ได้เลือกแพ็กเกจ', 'กรุณาเลือกแพ็กก่อนยืนยัน')
      return
    }

    const confirmQuotaUsage = await this._confirmQuotaUsage()
    if (!confirmQuotaUsage) {
      this._unSetLoading()
      return
    }
    if (isTaxReceiptRequested && _.isNil(subscriptionAddressContact)) {
      // @ts-ignore
      p.op.showConfirmationOkOnly('', 'กรุณาระบุที่อยู่ใบกํากับภาษี', () => this._navToEditAddressView())
      this._unSetLoading()
      return
    }

    // const price = this._getSumTotalPayment()
    // const whTex = this._getSumTotalWhTex()
    // const sumTotalPrice = isTaxWithheld ? price - whTex : price
    const items = _.isNil(addOnPackages) || addOnPackages.length === 0 ? [] : _.cloneDeep(addOnPackages)
    let mainPackage = null
    if (!_.isNil(selectedMainPackage)) {
      mainPackage = {
        sku: selectedMainPackage.sku,
        billing_cycle: selectedMainPackage.billing_cycle,
        qty: 1,
      }
    }
    // console.log('mainPackage => ', mainPackage)
    if (mode !== 'add_on') {
      items.push(mainPackage)
    }

    if (_.isNil(items) || items.length === 0) {
      p.op.showConfirmationOkOnly('', 'กรุณาเลือกแพ็กเกจ')
      this._unSetLoading()
      return
    }

    // const paidAt = dayjs(paymentPostDate).format('YYYY-MM-DD HH:mm:ss')
    // console.log('isTaxReceiptRequested //=> ', isTaxReceiptRequested)
    // return
    const reqBody = {
      user_id: profile.user_id,
      is_tax_withheld: isTaxWithheld,
      is_vat: true,
      is_tax_receipt_requested: isTaxReceiptRequested,
      total_amount: resultPayment.total_amount,
      // payment_method_id: 1, // DELETE ME LATER
      purchase_channel_id: 1, // NEW
      // payment: {
      //   paid_at: paidAt,
      //   ref_info: uploadedUrl,
      // },
      items,
    }

    if (!_.isNil(subscriptionAddressContact)) {
      // @ts-ignore
      reqBody.billing_address_id = subscriptionAddressContact.id
    }
    // console.log('reqBody => ', reqBody)
    const apiOptions: IApiOptions = {
      showSpinner: true,
    }

    const res: IResponseGetSubscriptionsOrder = await api.postV2('xselly/order/subscription/create', reqBody, apiOptions)
    // console.log('res => ', res)
    if (res?.id) {
      // p.op.showConfirmationOkOnly(
      //   'อัพโหลดหลักฐานการชำระเรียบร้อย',
      //   `กรุณารอระบบทำการตรวจสอบหลักฐานการชำระเงินภายใน 30 นาที ระบบจะอัพเดทแพ็กเกจของคุณให้อัตโนมัติเมื่อผ่านการตรวจสอบ`
      // )
      // p.op.showToast('อัพโหลดหลักฐานการชำระเรียบร้อย', 'success')
      const mainPackageSku = res.items.find((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // console.log('mainPackageSku => ', mainPackageSku)
      const newMainPackage = _.isNil(mainPackageSku)
        ? this.state.selectedMainPackage
        : subscriptionPackageList.items.find((item) => item.sku === mainPackageSku.sku)

      const newAddOnPackages = res.items.filter((item) => !_.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      await util.setStatePromise(this, {
        pendingOrderData: res,
        selectedMainPackage: newMainPackage,
        addOnPackages: newAddOnPackages,
        subscriptionAddressContact: _.has(res, 'billing_address') ? res.billing_address : null,
      })
    }
    this._unSetLoading()
    this._navToPaymentSubscriptionView()
    await util.delay(3000)
    // this.inLoopPamyntChackProcess = true
    // await this._loopChackPayment()
  }

  // _onSubmitPaymentDayAddOne = async () => {
  //   const { addOnPackages, selectedMainPackage, profile, paymentPostDate, uploadedUrl, subscriptionPackageList, mode } = this.state
  //   if (_.isNil(uploadedUrl)) {
  //     p.op.showConfirmationOkOnly('', 'อัพโหลดหลักฐานการชำระเงินไม่สำเร็จ')
  //     this._unSetLoading()
  //     return
  //   }
  //   const price = this._getSumTotalPayment()
  //   const items = _.isNil(addOnPackages) || addOnPackages.length === 0 ? [] : addOnPackages
  //   let mainPackage = null
  //   if (!_.isNil(selectedMainPackage)) {
  //     mainPackage = {
  //       sku: selectedMainPackage.sku,
  //       billing_cycle: selectedMainPackage.billing_cycle,
  //       qty: 1,
  //     }
  //   }
  //   // console.log('mainPackage => ', mainPackage)
  //   if (mode !== 'add_on') {
  //     items.push(mainPackage)
  //   }
  //   const paidAt = dayjs(paymentPostDate).format('YYYY-MM-DD HH:mm:ss')
  //   // console.log('profile => ', profile)
  //   // return
  //   const reqBody = {
  //     user_id: profile.user_id,
  //     is_tax_withheld: false,
  //     is_vat: true,
  //     is_tax_receipt_requested: false,
  //     total_amount: price,
  //     payment_method_id: 1,
  //     // payment_channel_id: 1,
  //     added_day: 1,
  //     payment: {
  //       paid_at: paidAt,
  //       ref_info: uploadedUrl,
  //     },
  //     items,
  //   }

  //   const apiOptions: IApiOptions = {
  //     showSpinner: true,
  //   }

  //   const res: IResponseGetSubscriptionsOrder = await api.postV2('subscription/order/create', reqBody, apiOptions)
  //   // console.log('res => ', res)
  //   if (res?.id) {
  //     // p.op.showConfirmationOkOnly(
  //     //   'อัพโหลดหลักฐานการชำระเรียบร้อย',
  //     //   `กรุณารอระบบทำการตรวจสอบหลักฐานการชำระเงินภายใน 30 นาที ระบบจะอัพเดทแพ็กเกจของคุณให้อัตโนมัติเมื่อผ่านการตรวจสอบ`
  //     // )
  //     p.op.showToast('อัพโหลดหลักฐานการชำระเรียบร้อย', 'success')
  //     const mainPackageSku = res.items.find((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
  //     // console.log('mainPackageSku => ', mainPackageSku)
  //     const newMainPackage = _.isNil(mainPackageSku)
  //       ? this.state.selectedMainPackage
  //       : subscriptionPackageList.items.find((item) => item.sku === mainPackageSku.sku)

  //     const newAddOnPackages = res.items.filter((item) => !_.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
  //     await util.setStatePromise(this, { pendingOrderData: res, selectedMainPackage: newMainPackage, addOnPackages: newAddOnPackages })
  //   }
  //   this._unSetLoading()
  //   await util.delay(3000)
  //   this.inLoopPamyntChackProcess = true
  //   await this._loopChackPayment()
  // }

  _renderCancelPayment = () => {
    // console.log('render cancel payment')
    this.props.fetchSubscription()
    this.goBack()
  }

  _navToPaymentSubscriptionView = () => {
    // @ts-ignore
    const { navigation } = this.props
    const { subscriptionPackageList, pendingOrderData, mode } = this.state
    this.inLoopPamyntChackProcess = false
    navigation.dispatch(
      NavActions.navToPaymentSubscriptionView({
        subscriptionPackageList,
        pendingOrder: pendingOrderData,
        succeedPaymentCallBack: (status: 'pending' | 'completed') => {
          // console.log('succeedPaymentCallBack status => ', status)
          if (status === 'completed') {
            this.props.fetchSubscription()
            // this.inLoopPamyntChackProcess = false
            const params = this._getParams()
            const { succeedPaymentCallBack } = params
            if (_.isFunction(succeedPaymentCallBack)) {
              succeedPaymentCallBack()
            }
            p.op.showToast('ระบบได้ทำการตรวจสอบการชำระเงินเรียบร้อยแล้ว', 'success')
            this.goBack()
          } else if (status === 'pending') {
            this.inLoopPamyntChackProcess = true
            this._loopChackPayment()
          } else {
            // ถ้าเป็นเคสที่ไม่รู้จักก็ให้กลับไปหน้าแพ็กเกจก่อนเพื่อรีเซ็ตข้อมูล เพื่อป้องกันการจ่ายเงินซ้ำ
            this.props.fetchSubscription()
            // this.inLoopPamyntChackProcess = false
            const params = this._getParams()
            const { succeedPaymentCallBack } = params
            if (_.isFunction(succeedPaymentCallBack)) {
              succeedPaymentCallBack()
            }
            this.goBack()
          }
        },
        mode,
        cancelPayment: () => this._renderCancelPayment(),
      })
    )
  }

  _loopChackPayment = async () => {
    const { pendingOrderData } = this.state
    if (_.isNil(pendingOrderData)) {
      return
    }
    const reqBody = {
      order_id: pendingOrderData.id,
    }
    const res: IResponseGetSubscriptionsOrder = await api.postV2(api.POST_ORDER_SUBSCRIPTION_GET, reqBody)
    // console.log('_loopChackPayment res => ', res)
    const { status } = res.payment
    if (!_.isNil(status) && status === 'unpaid' && res?.status === 'pending') {
      this.inLoopPamyntChackProcess = false
      return
    }
    if (res?.status === 'completed') {
      this.props.fetchSubscription()
      this.inLoopPamyntChackProcess = false
      const params = this._getParams()
      const { succeedPaymentCallBack } = params
      if (_.isFunction(succeedPaymentCallBack)) {
        succeedPaymentCallBack()
      }
      p.op.showConfirmationOkOnly('', 'ระบบได้ทำการตรวจสอบการชำระเงินเรียบร้อยแล้ว', () => {
        this.goBack()
      })
      this.inLoopPamyntChackProcess = false
      await util.setStatePromise(this, { pendingOrderData: res })
      return
    }

    if (res?.status === 'cancelled') {
      this.props.fetchSubscription()
      p.op.showConfirmationOkOnly('', 'ระบบได้ปฎิเสธการชำระเงิน', () => {
        this.inLoopPamyntChackProcess = false
        this.goBack()
      })
      this.inLoopPamyntChackProcess = false
      return
    }

    await util.setStatePromise(this, { pendingOrderData: res })

    await util.delay(3000)
    if (this.inLoopPamyntChackProcess) {
      await this._loopChackPayment()
    }
  }

  _showMainPackage = () => {
    const { pendingOrderData } = this.state
    if (!_.isNil(pendingOrderData)) {
      const { items } = pendingOrderData
      const mainPackage = items.filter((item) => _.includes(CONS.SUBSCRIPTION_MAIN_PACKAGE_SKU, item.sku))
      // console.log('isMainPackage => ', mainPackage)
      if (_.isNil(mainPackage) || mainPackage.length === 0) {
        return false
      }
    }

    return true
  }

  _getSumTotalQuota = (addOn: { title: string; addOnKey: string; cutSku: string }) => {
    const { selectedMainPackage, mode } = this.state
    if (_.isNil(selectedMainPackage)) {
      return null
    }
    let unitCount = selectedMainPackage?.data_json ? selectedMainPackage.data_json[addOn.addOnKey] : 0
    if (mode === 'upgrade') {
      // upgrade mode ต้องไปแปลง item_subtype ก่อน เพื่อนนำ item_subtype ไปคำนวณแสดงผลแพ็กเกจให้ถูกต้อง
      const newSelectedMainPackage = this._getMainPackageByUpgradePackageMode()
      const { data_json } = newSelectedMainPackage
      unitCount = !_.isNil(data_json) ? data_json[addOn.addOnKey] : 0
    }
    const getCountFromSelectedAddOn = this._getAddOnCount(addOn)
    unitCount += getCountFromSelectedAddOn
    const sumTotalAddonCurrentPackage = this._getSumAddonCurrentPackageBillingCycle(addOn.cutSku, addOn.addOnKey)
    const sumtotal = unitCount + sumTotalAddonCurrentPackage
    return sumtotal
  }

  // _pendingModeCheck = () => {
  //   const { selectedMainPackage, mode } = this.state
  //   const { sku } = selectedMainPackage
  //   if (CONS.SUBSCRIPTION_UPGRADE_PACKAGE_SKU.includes(sku)) {
  //     return 'upgrade'
  //   }
  //   return mode
  // }

  componentWillUnmount() {
    this.inLoopPamyntChackProcess = false
  }
}
